import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import * as UTILS from "../../../utils/Utils";
import Popup from "../../Modal/Popup";
import { track } from "@amplitude/analytics-browser"
// If you choose not to use import, you need to assign Cropper to default
// var Cropper = require('react-cropper').default

class AddToolButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showToolsSection: false,
    };

    this.wrapperRef = React.createRef();

  }


  openShowTools = () => {
    track('Add Elements Modal Open')
    this.setState({
      showToolsSection: !this.state.showToolsSection,
    });
  };

  // Changing the add button color to contrast color of background
  setForegroundColor = () => {
    let containerBg = this.props.containerBg;
    let rgb = [255, 255, 255, 100];
    if (this.props.containerBg && typeof this.props.containerBg === "string") {
      containerBg = UTILS.hexToRgbA(this.props.containerBg);
      containerBg = containerBg.replace("rgba(", "");
      containerBg = containerBg.replace(")", "");
      containerBg = containerBg.split(",");
      rgb = containerBg;
    } else {
      rgb = this.props.containerBg
        ? [
          this.props.containerBg.r,
          this.props.containerBg.g,
          this.props.containerBg.b,
          this.props.containerBg.a,
        ]
        : [255, 255, 255, 100];
    }
    let sum = Math.round(
      (parseInt(rgb[0]) * 299 +
        parseInt(rgb[1]) * 587 +
        parseInt(rgb[2]) * 114) /
      1000
    );
    return sum > 128 ? "#02597d" : "white";
  };

  render() {
    return (
      <Fragment>
   
          <div
            ref={this.wrapperRef}
            className={`addToolBtn--wrapper text-center`}
          >
            <span
              className="dragElementsText"
              style={
                this.props.forColumn == true
                  ? { color: "#02597d" }
                  : { color: this.setForegroundColor() }
              }
            >
              Drag Elements Here.
            </span>
            <div
              className="addToolBtn"
              style={{ borderColor: this.setForegroundColor() }}
              onClick={this.openShowTools}
            >
              <i
                className="fa fa-plus"
                style={{ color: this.setForegroundColor() }}
                aria-hidden="true"
              ></i>
              {/* <span
                className="addElementText"
                style={{ color: this.setForegroundColor() }}
              >
                Add
              </span> */}
            </div>


            {this.state.showToolsSection === true && (
              <Popup
                width="700"
                header="Add Elements"
                closePopup={() => {
                  this.setState({
                    showToolsSection: false,
                  });
                }}
                close={() => {
                  this.setState({
                    showToolsSection: false,
                  });
                }}
              >
                <div className="add-tool-popover">
                  {
                    <div className="row">
                      {this.props.tool.map((item, index) => {
                        // (item)
                        return (
                          <div
                            key={index}
                            id={index}
                            className={
                              "col-md-5 tool-icon " +
                              item.name 
                            }
                            onClick={(event) => {
                              track("Element Selected", {
                                elementType: item.name,
                                elementId: "modalAddElementButton",
                              });
                              event.preventDefault();
                              this.setState({
                                showToolsSection: false,
                              });
                              this.props.onAddElementorColumnInColumn(
                                event,
                                "tools",
                                item,
                                this.props.ID,
                                this.props.columnNumber
                              );
                            }}
                          >
                            <div
                              className={item.title}
                              id={index}
                           
                            >
                              {item.name}
                            </div>
                          </div>
                        );
                      })}

                      {this.props.block === true && (
                        <div
                          key={this.props.tool.length + 1}
                          id={this.props.tool.length + 1}
                          className={"col-md-12 text-center tool-icon Block"}
                        >
                          <div
                            className={`Block`}
                            id={this.props.tool.length + 1}
                            onClick={(event) => {
                              event.preventDefault();
                              this.setState({
                                showToolsSection: false,
                              });
                              this.props.onAddElementorColumnInColumn(
                                event,
                                "block",
                                null
                              );
                            }}
                          >
                            Block
                          </div>
                        </div>
                      )}
                    </div>
                  }
                </div>
              </Popup>
            )}
          </div>

      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    glblClrs: state.present.colorsGlobal,
    preset: state.present.preset,
    containerBg: state.present.containerBgColor,
    containerWidth: state.present.containerWidth,
    pixel: state.present.pixel,
    percentage: state.present.percentage,
    imagesGlobal: state.present.imagesGlobal,
    bgImage: state.present.bgImage,
    bgImageId: state.present.bgImageId,
    bgImageIndex: state.present.bgImageIndex,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    pushGlobalColorArray: (colorGlobal) =>
      dispatch(actionTypes.global_colors(colorGlobal)),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
    pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),
    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushBGimage: (image, id) => dispatch(actionTypes.bg_image(image, id)),
    pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
    pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToolButton);
